export default "__VITE_ASSET__7vwSCoKd__"